import { Row, Col, Button, Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { MockMainDashboard } from "../../../Public/Landingpages/Components/MockScreens";

const Welcome = ({ setShowRegister }) => {
  const [location, setLocation] = useState();

  useEffect(() => {
    const tmpLocation = window.location.hostname;
    setLocation(tmpLocation);
  }, []);

  return (
    <>
      <div className="lp-hero-bg">
        <Container>
          <Row className="align-items-center" style={{ paddingTop: "5rem", paddingBottom: "5rem", position: "relative" }}>
            <Col className="yellowdotWelcome" />
            <Col className="greendotWelcome" />
            <Col md={6} sm={12} style={{ marginBottom: "2rem" }}>
              <div className="lp-badge">All-in-one freelancer toolkit</div>
              <h1 className="lp-hero-title">
                Organize your
                <span style={{ color: "#007BFF" }}> freelancing </span>
                easily and efficiently
              </h1>
              <p className="lp-hero-subtitle">
                We provide all the tools you need to apply, manage, and bill your projects — from Start to End.
              </p>
              {location !== "demo.freelancersplace.net" ? (
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
                  <Button
                    className="lp-cta-btn"
                    onClick={() => setShowRegister(true)}
                  >
                    Try now for free
                  </Button>
                  <a href="https://demo.freelancersplace.net" target="_blank" rel="noreferrer" className="lp-demo-link">
                    View demo →
                  </a>
                </div>
              ) : null}
              <div className="lp-trust-badges">
                <span>✓ 30-day free trial</span>
                <span>✓ No credit card required</span>
              </div>
            </Col>

            <Col md={6} sm={12}>
              <Col className="reddotWelcome" />
              <MockMainDashboard />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Welcome;
